import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import IPv4Input from './IPv4Input';
import IPv4RangeInput from './IPv4RangeInput';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DeleteIcon from '@mui/icons-material/Delete';

function IPInputDialog(props) {
    const { open, onClose, variant, ipAddress } = props;
    const theme = useTheme();

    const [isValidIP, setIsValidIP] = React.useState(true);
    const [ipValue, setIPValue] = React.useState(null);
    const [ipList, setIPList] = React.useState(ipAddress || []);

    const inputIPDialogContent = {
        wild_card: {
            title: "Authorized IP Addresses (Wildcard Supported)",
            subTitle: "Add IPv4 addresses to allow access."
        },
        subnet_cidr: {
            title: "Add trusted IP ranges using CIDR/Subnet",
            subTitle: "Easily define entire networks (e.g. 192.168.0.0/24) to grant access to all IPs within a specific subnet."
        },
        range: {
            title: "Add trusted IP ranges",
            subTitle: "Add range of IPv4 addresses to allow access."
        }
    };

    const handleIPInputChange = (value, isValid) => {
        let duplicate_ip = false;
        if (isValid) {
            duplicate_ip = ipList.includes(value);
            if (!duplicate_ip) {
                setIPValue(value);
            }
        } else {
            duplicate_ip = false;
        }
        setIsValidIP(isValid ? duplicate_ip ? true : false : true);
    };

    const handleAddIP = () => {
        setIPList([ipValue, ...ipList]);
        setIPValue(null);
        setIsValidIP(true);
    };

    useEffect(() => {
        if (open && variant) {
            setIPList(ipAddress);
            setIsValidIP(true);
        }
    }, [ipAddress, open, variant])

    const handleIPRangeInputChange = (value, isValid) => {
        let duplicate_ip = false;
        if (isValid) {
            duplicate_ip = ipList.some(ip => {
                return ip.start === value.start && ip.end === value.end
            });
            if (!duplicate_ip) {
                setIPValue(value);
            }
        } else {
            duplicate_ip = false;
        }
        setIsValidIP(isValid ? duplicate_ip ? true : false : true);
    };

    const handleOnClose = () => {
        onClose(ipList);
        setIPList([])
    };

    return (
        <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={open}
        >
            <DialogTitle
                // sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.white.main }}
                sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.white.main, paddingY: 1, paddingX: 2 }}
                className='flex justify-between items-center'
            >
                <Typography>{inputIPDialogContent[variant]?.title}</Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleOnClose}
                    sx={{
                        padding: 0,
                        color: theme.palette.white.main
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ padding: 0 }}>
                <div className='w-full flex flex-col gap-4 p-[20px]'>
                    <Typography variant="subtitle2" className='text-gray-500'>{inputIPDialogContent[variant]?.subTitle}</Typography>
                    {variant !== 'range' ?
                        <div className='flex flex-row gap-4'>
                            <IPv4Input varaint={variant} onInputChange={handleIPInputChange} value={ipValue} />
                            <Button variant="contained" color="primary" className='h-[40px] w-[100px]' disabled={isValidIP} onClick={handleAddIP}>Add IP</Button>
                        </div>
                        :
                        <div className='flex flex-row gap-4'>
                            <IPv4RangeInput onInputChange={handleIPRangeInputChange} value={ipValue} />
                            <Button variant="contained" color="primary" className='h-[40px] w-[100px]' disabled={isValidIP} onClick={handleAddIP}>Add IP</Button>
                        </div>
                    }
                </div>
                <div className='w-full grid grid-cols-[70%_30%] bg-gray-200 px-[20px]'>
                    <Typography variant='subtitle2' lineHeight={3}>IP Address</Typography>
                    <Typography variant='subtitle2' lineHeight={3} ml={2}>Action</Typography>
                </div>
                <div className='min-h-[300px] mt-1 overflow-auto'>
                    {(variant && variant === 'range') &&
                        <>
                            {ipList.map((ip, index) => {
                                return (
                                    <div className='w-full grid grid-cols-[70%_30%] px-[20px] hover:bg-gray-50' key={index}>
                                        <Typography variant='subtitle2' lineHeight={3}>{ip.start} - {ip.end}</Typography>
                                        <div className='grid grid-cols-3'>
                                            <IconButton
                                                size="small"
                                                aria-label="copy"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(ip).then(() => {
                                                        // console.log(`Copied to clipboard: ${ip}`);
                                                    }).catch(err => {
                                                        // console.error('Failed to copy: ', err);
                                                    });
                                                }}
                                            >
                                                <FileCopyIcon fontSize='small' />
                                            </IconButton>
                                            <IconButton
                                                // size="small"
                                                aria-label="remove"
                                                onClick={() => {
                                                    const newValue = ipList.filter(i => i !== ip)
                                                    setIPList(newValue);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                )
                            })}
                        </>
                    }
                    {(variant && variant !== 'range') &&
                        <>
                            {ipList.map((ip, index) => {
                                return (
                                    <div className='w-full grid grid-cols-[70%_30%] px-[20px] hover:bg-gray-50' key={index}>
                                        <Typography variant='subtitle2' lineHeight={3}>{ip}</Typography>
                                        <div className='grid grid-cols-3'>
                                            <IconButton
                                                size="small"
                                                aria-label="copy"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(ip).then(() => {
                                                        // console.log(`Copied to clipboard: ${ip}`);
                                                    }).catch(err => {
                                                        // console.error('Failed to copy: ', err);
                                                    });
                                                }}
                                            >
                                                <FileCopyIcon fontSize='small' />
                                            </IconButton>
                                            <IconButton
                                                // size="small"
                                                aria-label="remove"
                                                onClick={() => {
                                                    // console.log("ipList", ipList)
                                                    const newValue = ipList.filter(i => i !== ip)
                                                    setIPList(newValue);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                )
                            })}
                        </>
                    }
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default IPInputDialog